export const EXCEL_COLUMNS = [
    { header: '検索キーワード', key: 'searchKeyword', width: 30 },
    { header: 'ヒット数', key: 'searchCount', width: 10 },
    { header: '除外キーワード', key: 'excludeKeyword', width: 30 },
    { header: 'ヒット数', key: 'excludeCount', width: 10 }
];

export const FILE_NAME = 'キーワードカウント結果.xlsx';
export const FONT_COLOR_RED = 'FFFF0000';
export const FONT_COLOR_BLUE = 'blue';

export const FILE_LINK = '/files/InspectionReport.xlsx';
export const SHEET_NAME = '●●省';
export const DOWNLOAD_FILE_NAME = '06_（別紙２）令和●年●●国会提出予定法案に係るデジタル原則適合性の点検結果報告表.xlsx';

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
